import(/* webpackMode: "eager", webpackExports: ["AppRouterI18nProvider"] */ "/srv/calcom/apps/web/app/AppRouterI18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/srv/calcom/apps/web/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/srv/calcom/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/srv/calcom/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\",\"preload\":true,\"display\":\"swap\"}],\"variableName\":\"interFont\"}");
;
import(/* webpackMode: "eager" */ "/srv/calcom/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/CalSans-SemiBold.woff2\",\"variable\":\"--font-cal\",\"preload\":true,\"display\":\"block\",\"weight\":\"600\"}],\"variableName\":\"calFont\"}");
;
import(/* webpackMode: "eager" */ "/srv/calcom/apps/web/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/calcom/node_modules/react-inlinesvg/dist/index.mjs");
